import { render, staticRenderFns } from "./save_language_data_modal.vue?vue&type=template&id=d3c6a874&scoped=true"
import script from "./save_language_data_modal.vue?vue&type=script&lang=js"
export * from "./save_language_data_modal.vue?vue&type=script&lang=js"
import style0 from "./save_language_data_modal.vue?vue&type=style&index=0&id=d3c6a874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c6a874",
  null
  
)

export default component.exports